import React, { useState } from "react";
import styles from "./Library.module.scss";
import { listPatterns, Pattern } from "./patterndb";
import { ToggleButton } from "./ToggleButton";

enum Trick {
  Mills,
  Passing,
  Multiplex,
  Box,
}

interface LibraryProps {
  onPatternChange(p: Pattern): void;
}

export function Library(props: LibraryProps) {
  const [state, setState] = useState({
    propCount: 3,
    propCountActive: false,
  } as {
    propCount: number;
    propCountActive: boolean;
    trick: Trick | undefined;
  });

  function pickPattern(pattern: Pattern) {
    props.onPatternChange(pattern);
  }

  function onPropCountSliderChange(propCount: number) {
    setState({
      ...state,
      propCount: propCount,
      propCountActive: true,
    });
  }

  function filterByPropCount() {
    setState({
      ...state,
      propCountActive: !state.propCountActive,
    });
  }

  const patterns = listPatterns().filter((p) => {
    if (state.propCountActive && p.meta.propCount !== state.propCount) {
      return false;
    }
    switch (state.trick) {
      case Trick.Passing:
        if (!p.meta.passing) {
          return false;
        }
        break;

      case Trick.Mills:
        if (p.meta.handSequenceName !== "Mills Mess") {
          return false;
        }
        break;

      case Trick.Multiplex:
        if (!p.meta.multiplex) {
          return false;
        }
        break;

      case Trick.Box:
        if (p.name.toLowerCase().indexOf("box") < 0) {
          return false;
        }
    }
    return true;
  });

  return (
    <div className={styles.library}>
      <div className={styles.filters}>
        <div className={styles.slider}>
          <ToggleButton
            active={state.propCountActive}
            onClick={() => filterByPropCount()}
          >
            {state.propCount}
          </ToggleButton>
          <input
            onChange={(e) => onPropCountSliderChange(e.target.valueAsNumber)}
            value={state.propCount}
            type="range"
            min={1}
            max={9}
          />
        </div>
        <div className={styles.tricks}>
          {([
            [Trick.Box, "Box"],
            [Trick.Mills, "Mess"],
            [Trick.Multiplex, "Multi"],
            [Trick.Passing, "Pass"],
          ] as Array<[Trick, string]>).map((t) => (
            <ToggleButton
              key={t[1]}
              active={state.trick === t[0]}
              onClick={() =>
                setState({
                  ...state,
                  trick: state.trick === t[0] ? undefined : t[0],
                })
              }
            >
              {t[1]}
            </ToggleButton>
          ))}
        </div>
      </div>
      <div className={styles.patterns}>
        {patterns.length > 0 ? (
          patterns.map((pattern: Pattern, i) => {
            return (
              <div
                className={styles.pattern}
                onClick={(e) => pickPattern(pattern)}
                key={i}
              >
                {pattern.name}
              </div>
            );
          })
        ) : (
          <div className={styles.none}>No matches</div>
        )}
      </div>
    </div>
  );
}
